// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store/store'
import Vuex from 'vuex'
Vue.use(Vuex)
import local from './utils/localStorage'
Vue.prototype.$L = local; // 本地相关操作

import App from './App'
import router from './config/router'
import ElementUI from 'element-ui'
// import './theme/index.css';
import 'element-ui/lib/theme-chalk/index.css'

// 引入组件
import AceContainer from './components/container/index'

Vue.use(ElementUI).use(AceContainer)


/* eslint-disable no-new */
const zm = new Vue({
	router,
	store,
	// template: '<App/>'
	render :h => h(App)
}).$mount("#app")

export default zm;



// WEBPACK FOOTER //
// ./src/main.js